module.exports = __webpack_public_path__ + "static/media/administration_viejo.88a748e6.svg";